import input from "./input";
var register = {
  parts: ["field"],
  sizes: input.register.sizes,
  variants: input.register.variants
};
var baseStyle = input.baseStyle;
var variants = input.variants;
var sizes = {
  lg: {
    field: {
      fontSize: "lg",
      width: 12,
      height: 12,
      borderRadius: "md"
    }
  },
  md: {
    field: {
      fontSize: "md",
      width: 10,
      height: 10,
      borderRadius: "md"
    }
  },
  sm: {
    field: {
      fontSize: "sm",
      width: 8,
      height: 8,
      borderRadius: "sm"
    }
  }
};
var defaultProps = input.defaultProps;
var pinInput = {
  register,
  defaultProps,
  baseStyle,
  variants,
  sizes
};
export default pinInput;
//# sourceMappingURL=pin-input.js.map